import { basicStyles as _contentSliderStyles } from 'sletat-ui-components/lib/ContentSlider/themes/basic';

import {
    MORE_1024_MEDIA_QUERY,
    MORE_375_MEDIA_QUERY,
    MORE_440_MEDIA_QUERY,
    MORE_512_MEDIA_QUERY,
    MORE_620_MEDIA_QUERY,
    MORE_768_MEDIA_QUERY,
    MORE_984_MEDIA_QUERY
} from '../../../consts/adaptive';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';


const imageLoaderStyles = {
    '& .uikit-loader': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#e1e1e1',
        borderRadius: 2,
        height: '100%',
        paddingRight: 12,

        '&__spinner > div': {
            backgroundColor: '#999'
        }
    },
    '& .uikit-image-with-loader__img': {
        width: '100%',
        height: '100%',
        margin: 0,
        objectFit: 'cover',
        borderRadius: defaultTheme.theme.borderRadiusVariables.main,
    }
};

export const styles = {
    container: {
        ...imageLoaderStyles,
        position: 'relative',
        paddingBottom: 16,

        '& .uikit-image-with-loader': {
          display: 'block',
          height: '100%',
        }
    },
    hotelLabels: {
        position: 'absolute',
        top: 8,
        left: 20,
        padding: [4, 8],
        borderRadius: 2,
        color: '#8b572a',
        fontSize: 12,
        backgroundColor: '#fff9b1',
        zIndex: 1
    },
    onePhotoWrap: {
        paddingRight: 12,

        ...imageLoaderStyles
    },
    [MORE_984_MEDIA_QUERY]: {
        container: {
            paddingLeft: 0,
            backgroundColor: '#fff'
        }
    },
    [MORE_1024_MEDIA_QUERY]: {
        hotelLabels: {
            top: 12,
            left: 24,
            fontSize: 14
        },
        onePhotoWrap: {
            paddingRight: 0
        }
    }
};

const sliderArrowsStyles = {
    position: 'absolute',
    top: 0,
    zIndex: 1,
    width: 64,
    // TODO ziserman нужно сейчас для позиционирования стрелок, убрать до релиза адаптива
    height: '99.27%',
    border: 0,
    backgroundColor: 'rgba(0, 0, 0, 0)',
    backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA5IDE2Jz48cGF0aCBmaWxsPScjZmZmJyBkPSdNNy44NiAxLjE0Yy4yLjIuMi41NCAwIC43NWwtNi42IDYuNiA2LjYgNi42Yy4yLjIuMi41NCAwIC43NC0uMi4yLS41NC4yLS43NSAwTC4xNyA4Ljg3Qy4wNiA4Ljc3IDAgOC42NCAwIDguNWMwLS4xMy4wNS0uMjcuMTYtLjM4TDcuMSAxLjE1Yy4yMi0uMjIuNTUtLjIyLjc2IDB6Jy8+PC9zdmc+")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: [15, 30],
    backgroundPosition: 'center',
    cursor: 'pointer'
};

export const contentSliderStyles = {
    ..._contentSliderStyles,
    container: {
        ..._contentSliderStyles.container,
        display: 'block',

        '& .uikit-image-with-loader': {
            paddingRight: 8,
            boxSizing: 'border-box'
        },
    },
    frame: {
        ..._contentSliderStyles.frame,
        outline: 0,
    },
    slidesPanel: {
        ..._contentSliderStyles.slidesPanel,
        height: 'inherit',
    },
    counterBlock: {
        ..._contentSliderStyles.counterBlock,
        position: 'absolute',
        right: '15.5%', // получено эмпирически, к сожалению, другого быстрого решения пока нет
        bottom: 13,
        padding: [4, 8],
        color: '#fff',
        fontSize: 12,
        backgroundColor: '#313140',
        borderRadius: 2
    },
    leftArrow: {
        ...sliderArrowsStyles,
        left: 0,

        '&:hover': {
            backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA5IDE2Jz48cGF0aCBmaWxsPScjMzliY2ViJyBkPSdNNy44NiAxLjE0Yy4yLjIuMi41NCAwIC43NWwtNi42IDYuNiA2LjYgNi42Yy4yLjIuMi41NCAwIC43NC0uMi4yLS41NC4yLS43NSAwTC4xNyA4Ljg3Qy4wNiA4Ljc3IDAgOC42NCAwIDguNWMwLS4xMy4wNS0uMjcuMTYtLjM4TDcuMSAxLjE1Yy4yMi0uMjIuNTUtLjIyLjc2IDB6Jy8+PC9zdmc+")'
        }
    },
    leftArrowDisabled: {
        extend: 'leftArrow',
        opacity: 0,
        cursor: 'default',

        '&:hover': {
            backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA5IDE2Jz48cGF0aCBmaWxsPScjZmZmJyBkPSdNNy44NiAxLjE0Yy4yLjIuMi41NCAwIC43NWwtNi42IDYuNiA2LjYgNi42Yy4yLjIuMi41NCAwIC43NC0uMi4yLS41NC4yLS43NSAwTC4xNyA4Ljg3Qy4wNiA4Ljc3IDAgOC42NCAwIDguNWMwLS4xMy4wNS0uMjcuMTYtLjM4TDcuMSAxLjE1Yy4yMi0uMjIuNTUtLjIyLjc2IDB6Jy8+PC9zdmc+")'
        }
    },
    rightArrow: {
        ...sliderArrowsStyles,
        right: 0,
        transform: 'rotate(180deg)',

        '&:hover': {
            backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA5IDE2Jz48cGF0aCBmaWxsPScjMzliY2ViJyBkPSdNNy44NiAxLjE0Yy4yLjIuMi41NCAwIC43NWwtNi42IDYuNiA2LjYgNi42Yy4yLjIuMi41NCAwIC43NC0uMi4yLS41NC4yLS43NSAwTC4xNyA4Ljg3Qy4wNiA4Ljc3IDAgOC42NCAwIDguNWMwLS4xMy4wNS0uMjcuMTYtLjM4TDcuMSAxLjE1Yy4yMi0uMjIuNTUtLjIyLjc2IDB6Jy8+PC9zdmc+")'
        }
    },
    rightArrowDisabled: {
        extend: 'rightArrow',
        opacity: 0,
        cursor: 'default',

        '&:hover': {
            backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA5IDE2Jz48cGF0aCBmaWxsPScjZmZmJyBkPSdNNy44NiAxLjE0Yy4yLjIuMi41NCAwIC43NWwtNi42IDYuNiA2LjYgNi42Yy4yLjIuMi41NCAwIC43NC0uMi4yLS41NC4yLS43NSAwTC4xNyA4Ljg3Qy4wNiA4Ljc3IDAgOC42NCAwIDguNWMwLS4xMy4wNS0uMjcuMTYtLjM4TDcuMSAxLjE1Yy4yMi0uMjIuNTUtLjIyLjc2IDB6Jy8+PC9zdmc+")'
        }
    },
    [MORE_375_MEDIA_QUERY]: {
        counterBlock: {
            right: '15%'
        }
    },
    [MORE_440_MEDIA_QUERY]: {
        counterBlock: {
            right: '14%'
        }
    },
    [MORE_512_MEDIA_QUERY]: {
        counterBlock: {
            right: '13.5%'
        }
    },
    [MORE_620_MEDIA_QUERY]: {
        counterBlock: {
            right: '13%'
        }
    },
    [MORE_768_MEDIA_QUERY]: {
        counterBlock: {
            right: '12.5%'
        }
    },
    [MORE_984_MEDIA_QUERY]: {
        counterBlock: {
            right: '12%'
        }
    },
    [MORE_1024_MEDIA_QUERY]: {
        counterBlock: {
            fontSize: 14,
            top: 12,
            right: 12,
            bottom: 'auto'
        }
    }
};

export type ComponentJSSClasses = typeof styles;
